import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import TopHeader from './components/TopHeader';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import CategoryCards from './components/CategoryCards';
import VolunteerSection from './components/VolunteerSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ServicesSectionMobile from './components/ServicesSectionMobile';
import ProjectsGrid from './components/ProjectsGrid';
import ServiceDetail from './components/ServiceDetail';
import ProjectDetail from './components/ProjectDetail';
import DonationBanner from './components/DonationBanner';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import Contact from './components/Contact';
import About from './components/About';
import Blogs from './components/Blogs';
import BlogDetail from './components/BlogDetail';
import Events from './components/Events';
import EventDetail from './components/EventDetail';
import Donation from './components/Donation';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Refund from './components/Refund';
import AdminMessages from './components/AdminMessages';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import useStickyHeader from './components/StickyHeader';

function HomePage() {
  useStickyHeader();

  return (
    <div className="App">
      <TopHeader />
      <Header />
      <main className="main-content">
        <HeroSlider />
        <CategoryCards />
        <VolunteerSection />
        <div className="container">
          <AboutSection />
          <ServicesSectionMobile />
          <ServicesSection />
          <ProjectsGrid />
        </div>
        <DonationBanner />
        <div className="container">
          <TestimonialsCarousel />
          <ContactForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}

const PageLayout = () => {
  useStickyHeader();

  return (
    <>
      <TopHeader />
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route element={<PageLayout />}>
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/donation" element={<Donation />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/messages"
            element={( 
              <ProtectedRoute>
                <AdminMessages />
              </ProtectedRoute>
            )}
          />
        </Route>
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
